var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["ui-notification", { "ui-notification-shake": _vm.shaking }],
      style: { borderColor: _vm.color }
    },
    [
      _c("div", { staticClass: "ui-notification-content" }, [
        _vm.title
          ? _c("div", {
              staticClass: "ui-notification-title",
              domProps: { textContent: _vm._s(_vm.title) }
            })
          : _vm._e(),
        _vm.$slots.default
          ? _c(
              "div",
              { staticClass: "ui-notification-subtitle" },
              [_vm._t("default")],
              2
            )
          : _vm._e()
      ]),
      _vm.$slots.action
        ? _c(
            "div",
            { staticClass: "ui-notification-action" },
            [_vm._t("action")],
            2
          )
        : _vm._e(),
      _vm.closable
        ? _c(
            "div",
            {
              staticClass: "ui-notification-close",
              on: {
                click: function($event) {
                  return _vm.$emit("remove")
                }
              }
            },
            [
              _c("f-sprite-icon", {
                attrs: { "icon-link": _vm.$options.icons.IconClose.id }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }